import { render, staticRenderFns } from "./CustSelect.vue?vue&type=template&id=ded53afc&"
import script from "./CustSelect.vue?vue&type=script&lang=js&"
export * from "./CustSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports